import { IconButton, Tooltip } from "@mui/material";
//import  "../../../../css/Purchase Manager/StockAdjustment/requestForQuatationNw.css"
import React from "react";
import Draft from "../../../../../Assets/statusRibbon/draft.png";
import postRibbon from "../../../../../Assets/statusRibbon/post.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { companyProfileInfoForUser, debitNoteSingleViewApiCall, viewCompanyProfileInfoAPICall } from "../../../../../API/Settings/Company Settings/companySettingsAPI";
import { useRef } from "react";
import { useReactToPrint } from "../../../../Shared/print/useHtml2PdfPrint";
import ReactToPrint from "../../../../Shared/print/ReactToPrint";
import { convertDateFormat, today } from "../../../../../Js/Date";
import { getTemplateAPI } from "../../../SalesNew/SalesOrders/SalesQuotation/salesQuatationAPI";
import Template1 from "../../../SalesNew/SalesOrders/SalesQuotation/Template1";
import Template2 from "../../../SalesNew/SalesOrders/SalesQuotation/Template2";
import { set_Back_button_action } from "../../../../Single Components/listSlice/filterCategorySlice";
import { InvoiceContent } from "../../PrintComponents/printTemplates/common/InvoiceContent";
import { printSection } from "../../PrintComponents/printTemplates/common/enum";

export const DebitNoteSingleView = () => {

  const singleViewID = localStorage.getItem('singleViewById');
  const dispatch = useDispatch();
  let paymentsPrint = useRef();
  let paymentsPrintNew = useRef();
  const componentRef = useRef();

  //data of selected list
  const singleList = useSelector((state) => state?.debitNoteSlice?.rowData);


const template =useSelector((state)=>state?.salesQuatationSlice?.setTemplate)

  // company details and info
 
  const companyProfileData =useSelector(
    (state) => state?.companyProfileSlice?.userValue)
 //console.log(companyProfileData);
  //initial value
  const formValuesInitialState = {
    status: "",
    companyLogo: "",
    companyName: "",
    companyAddress: "",
    companyContact: "",
    companyTRN: "",

    customerName: "",
    customerAddress: "",
    customerContact: "",
    trn:"",


    address:"Vendor ",

    lpo:"",
    ref: "",
    name: "",
    firstDate: "",
    dateN1:"Return Date",
    dateN2:"Expiry Date",
    secondDate: "",
    expiry:"",
    subtotal: "",

    termsAndCondition:"",

    total: "",
    totalAmount:"",
    payTerm:"",
    sequence:"Return No",
    label:"PURCHASE RETURN"
  };
  const [formValues, setFormValues] = useState(formValuesInitialState);

  const [data, setData] = useState([]);
  const [tax, setTax] = useState([]);
  const [domain, setDomain] = useState("");

  useEffect(() => {
    setFormValues({
      ...formValues,
      status: singleList?.status,
      companyLogo: companyProfileData?.logo || "",
      companyName: companyProfileData?.companyName || "",
      companyAddress: companyProfileData?.companyAddress || "",
      companyContact: companyProfileData?.contactNumber || "",
      companyTRN: companyProfileData?.companyTRN || "",

      lpo: singleList?.LpoNo ||"",
      customerName: singleList?.vendorAddress?.vendorName || "",
      customerAddress: singleList?.vendorAddress?.streetName || "",
      customerContact: singleList?.vendorAddress?.mobileNo || "",
      trn: singleList?.vendorAddress?.TRN || "",

      termsAndCondition:singleList?.termsAndConditions || "",

      ref: singleList?.paymentRef|| "",
      subtotal: singleList?.subTotal || "",
      name: singleList?.name || "",
      firstDate: singleList?.accountingDate || "",
     expiry: singleList?.billDate || "",
      totalAmount: singleList?.totalAmount || "",
      total: singleList?.total || "",
      payTerm: singleList?.PAYMENTTERM || "",
    });
    setTax(singleList?.taxDetails)
    setData(singleList?.productInfo);
  }, [singleList, companyProfileData]);

  // api to fetch companyprofile data
  useEffect(() => {
    getTemplateAPI();
    debitNoteSingleViewApiCall({_id:singleViewID});

  }, []);

  let navigateTo = useNavigate();
  return (
    <div className="main-container"style={{ backgroundColor: "unset", padding: "0" }}>
      <div className="first-div-container"style={{ backgroundColor: "white", justifyContent: "space-between" }}>
        {/* <div className="post-ribbon">
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
        </div> */}
        <div style={{display:"flex",gap:"8px"}}>
       
        <Tooltip title="Edit">
          <IconButton>
            <i
              class="bi bi-pencil-square edit-icon1"
              onClick={() =>
                navigateTo(
                  "/userdashboard/accounts/vendor/DebitNotes/create"
                )
              }
            ></i>
          </IconButton>
        </Tooltip>
       
          <h3>
            <span
             style={{ fontSize: "medium", color: "black", cursor: "pointer" }}

              onClick={() =>
               { navigateTo("/userdashboard/accounts/vendor/DebitNotes")
               dispatch(set_Back_button_action({ backButtonClickAction: true }));
              }
              }
            >Debit Note &gt;</span>
         <span style={{fontSize:"medium",paddingLeft:"8px"}}>{formValues?.name}</span>

          </h3>
        
        </div>
        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div">
              <i style={{ color: "black" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrint}
        /> */}
        <div>
        <Tooltip title="Share">
          <IconButton>
            <i class="bi bi-share" style={{ backgroundColor: "#9797e9", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>

        {/* <ReactToPrint
          trigger={() => (
            <IconButton className="printer-div" style={{ padding: "1px" }}>
              <i style={{ color: "white", backgroundColor: " #d787e7", fontSize: "medium", padding: "8px", borderRadius: "2px" }} class="bi bi-printer"></i>
            </IconButton>
          )}
          content={() => paymentsPrintNew}
        /> */}
         <ReactToPrint
            // The print button
            trigger={() => (
              <IconButton className="printer-div" style={{ padding: "1px" }}>
                <i
                  style={{
                    color: "white",
                    backgroundColor: " #d787e7",
                    fontSize: "medium",
                    padding: "8px",
                    borderRadius: "2px",
                  }}
                  class="bi bi-printer"
                ></i>
              </IconButton>
            )}
            // The content to be printed (InvoiceContent component)
            content={() => componentRef.current}
            // Set the page style for printing
            pageStyle="@page { size: A4; margin: 0; }"
          />

        <Tooltip title="Download">
          <IconButton>
            <i class="bi bi-arrow-down-circle" style={{ backgroundColor: "rgb(255 118 133 / 69%)", color: "white", fontSize: "medium", padding: "8px", borderRadius: "2px" }}></i>
          </IconButton>
        </Tooltip>
        </div>
      </div>
      {/* <hr className="line" /> */}
      <div style={{ backgroundColor: "white", height: "80vh", marginTop: "4px", position: "relative" }}>
        
      <div className="second-main-container">
      <div className="post-ribbon" style={{right:"0",top:'0'}}>
          {formValues?.status === "DRAFT" && <img src={Draft} alt="" />}
          {formValues?.status === "POSTED" && <img src={postRibbon} alt="" />}
        </div>
        <div className="left-side-div">
          <img src={formValues?.companyLogo} alt={formValues?.companyName} />
          <p>{formValues?.companyAddress}</p>
          <p>{formValues?.companyContact}</p>

          <h1 className="vendor-head">Vendor Address</h1>
          <p>{formValues?.customerName}</p>
          <p>{formValues?.customerAddress}</p>
          <p>{formValues?.customerContact}</p>
          {/* <p>--</p>
          <p>--</p> */}
        </div>
        <div className="right-side-div">
          <h1>Debit Note </h1>
          <p>{formValues?.name}</p>
          <div className="date-div">
            <p>
              <span class="date-container-single">Date:</span>
              {formValues?.firstDate}
            </p>
            <p>
              <span class="date-container-single">Bill Date:</span>
              {formValues?.expiry}
            </p>
          </div>
        </div>
      </div>

      <div className="Table-container">
        <div className="Table-data">
          <table>
            <thead>
              <tr style={{ backgroundColor: "#eaeef9" }}>
                <th>No</th>
                <th>Product</th>
                <th>UOM</th>
                <th>QTY</th>
                <th>Unit Price</th>
                <th>Discount</th>
                <th>Tax</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                  }}
                >
                  <td>{index + 1}</td>
                  <td>{item.product}</td>
                  <td>{item.uomName}</td>
                  <td>{item.qty}</td>
                  <td>{item.unitPrice}</td>
                  <td>{item.discount}</td>
                  <td
                    style={{
                      display: "flex",
                      placeContent: "center",
                      marginTop: "10px",
                    }}
                  >
                    {item.taxIdList?.map((r, i) => (
                      <p key={i}  style={{ margin: "1px" }}>
                        {r?.taxName}
                      </p>
                    ))}
                  </td>
                  <td>{(item?.qty)*(item?.unitPrice)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="last-total-div">
            <div className="sub-total">
              {/* <h1>Sub Total</h1>
            <p>Discount(2.00%)</p>
            <p>standard Rate(2.00%)</p>
            <hr className='line-2' /> */}
              <h1>Total</h1>
            </div>
            <div className="sub-total-amount">
              {/* <h1>$124,754.00</h1>
            <p>4000</p>
            <p>5000</p>
            <hr className='line-3' /> */}
              <h1>{formValues.total || "---"}</h1>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      {/* payments print view */}
      <div style={{ display: "none" }}>
        <div ref={(el) => (paymentsPrint = el)}>
          <div className="print-view-top-container">
            <div
              className="print-view-top-left-container"
              style={{ width: "25%" }}
            >
              <p></p>
              <p></p>
            </div>
            <div
              className="print-view-top-middle-container"
              style={{ width: "50%" }}
            >
              {/* <h3>--</h3>

              <h3>--</h3> */}

              <p>Customer Invoice</p>
            </div>

            <div
              className="print-view-top-right-container"
              style={{ width: "25%" }}
            >
              <p>{convertDateFormat(today)}</p>
              <p>{""}</p>
            </div>
          </div>

          <div className="second-main-container">
            <div className="left-side-div">
              <img
                src={formValues?.companyLogo}
                alt={formValues?.companyName}
              />
              <p>{formValues?.companyAddress}</p>
              <p>{formValues?.companyContact}</p>

              <h1 className="vendor-head">Vendor Address</h1>
              <p>{formValues?.vendorName}</p>
              {/* <p>--</p>
              <p>--</p> */}
            </div>
            <div className="right-side-div">
              <h1>Debit Note </h1>
              <p>{formValues?.name}</p>
              <div className="date-div">
                <p>
                  <span class="date-container-single">Date:</span>
                  {formValues?.Date}
                </p>
                <p>
                  <span class="date-container-single">Bill Date:</span>
                  {formValues?.billDate}
                </p>
              </div>
            </div>
          </div>

          <div className="Table-container" style={{ padding: "0px 35px" }}>
            <div className="Table-datas">
              <table style={{ overflow: "none" }}>
                <thead>
                  <tr style={{ backgroundColor: "#eaeef9" }}>
                    <th>No</th>
                    <th>Product</th>
                    <th>Account</th>
                    <th>UOM</th>
                    <th>QTY</th>
                    <th>Unit Price</th>
                    <th>Discount</th>
                    <th>Tax</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 === 0 ? "#f1f2f5" : "white",
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>{item.product}</td>
                      <td>{item.account}</td>
                      <td>{item.uomName}</td>
                      <td>{item.qty}</td>
                      <td>{item.unitPrice}</td>
                      <td>{item.discount}</td>
                      <td
                        style={{
                          display: "flex",
                          placeContent: "center",
                          marginTop: "10px",
                        }}
                      >
                        {item.taxes?.map((r, i) => (
                          <p key={i} className="tax" style={{ margin: "1px" }}>
                            {r?.amount}%
                          </p>
                        ))}
                      </td>
                      <td>--</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="last-total-div">
                <div className="sub-total">
                  {/* <h1>Sub Total</h1>
            <p>Discount(2.00%)</p>
            <p>standard Rate(2.00%)</p>
            <hr className='line-2' /> */}
                  <h1>Total</h1>
                </div>
                <div className="sub-total-amount">
                  {/* <h1>$124,754.00</h1>
            <p>4000</p>
            <p>5000</p>
            <hr className='line-3' /> */}
                  {/* <h1>--</h1> */}
                </div>
              </div>
            </div>
          </div>
          <div className="terms">
            <h1>Terms & Conditions</h1>
            <hr className="lines" />
          </div>
        </div>
      </div>
      {/* <div style={{ display: "none" }}>
  <div ref={(el) => (paymentsPrintNew = el)}>
    {template?.templateModel === 'template1' ? (
      <Template1 data={data} formValues={formValues} tax={tax} />
    ) : (
      <Template2 data={data} formValues={formValues} tax={tax}/>
    )}
  </div>
</div> */}
<div style={{ display: "none" }}>
        <div ref={(el) => (paymentsPrintNew = el)}>
          <InvoiceContent
            invoiceDetails={{ ...formValues, printSection: printSection.debitNote }}
            ref={componentRef}
            printData={data}
            taxDetails={tax}
            qrData={domain}
          />
        </div>
      </div>
    </div>
  );
};
